import { DashboardBudgetResponse } from "@/models/homePage";
import { makeAutoObservable } from "mobx";

export class HomePageStore {
    dashboardBudgetData: DashboardBudgetResponse = new DashboardBudgetResponse();

    constructor() {
        makeAutoObservable(this);
    }

    public setDashboardBudgetData(request: DashboardBudgetResponse) {
        this.dashboardBudgetData = request;
    }
}

export default new HomePageStore();